import { render } from "./organisation_structure.html?vue&type=template&id=d2401aea&external"
import script from "./organisation_structure.js?vue&type=script&lang=js&external"
export * from "./organisation_structure.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__